import type { Editor } from '@tiptap/react'
import { useTranslations } from 'next-intl'
import type { VariantProps } from 'class-variance-authority'
import type { toggleVariants } from '@/components/ui/toggle'
import { useState } from 'react'
import { FaYoutube } from 'react-icons/fa'
import { ToolbarButton } from '../toolbar-button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { YoutubeEditBlock } from './youtube-edit-block'
import { Image, Youtube } from 'lucide-react'

interface YoutubeEditDialogProps extends VariantProps<typeof toggleVariants> {
  editor: Editor
}

const YoutubeEditDialog = ({
  editor,
  size,
  variant,
}: YoutubeEditDialogProps) => {
  const t = useTranslations('tiptap')
  const [open, setOpen] = useState(false)

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <ToolbarButton
          isActive={editor.isActive('youtube')}
          tooltip="youtube"
          aria-label="youtube"
          size={size}
          variant={variant}
        >
          <FaYoutube className="size-5" />
        </ToolbarButton>
      </DialogTrigger>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{t('add_youtube_link')}</DialogTitle>
          <DialogDescription className="sr-only">
            {t('add_youtube_link')}
          </DialogDescription>
        </DialogHeader>
        <YoutubeEditBlock editor={editor} close={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export { YoutubeEditDialog }
